var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-title"},[_c('div',{staticClass:"s-subtitle theme-after dark-color"},[_vm._t("p-1")],2),_c('div',{staticClass:"st-title"},[_c('div',{staticClass:"s-title theme-after dark-color"},[_vm._t("p-2")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }